const value = {
    title: 'Доступ закрыт',
    message:
      'Чтобы открыть раздел, обратитесь к администратору. Если у вас остались вопросы, наша служба поддержки на связи:',
  };

export default value;
